import type { SVGProps } from 'react'

/**
 * Das Zeichensatz der App — eine Datei, ein Stil: 24er-Raster, nur Konturen,
 * 1.8 px Strichstärke, `currentColor`. Kein Icon-Paket: ein Dutzend Glyphen
 * wiegen nichts, ein Paket wiegt hundert Kilobyte und bringt einen fremden
 * Stil mit.
 */
export type SymbolName =
  | 'home'
  | 'calendar'
  | 'tasks'
  | 'shopping'
  | 'activity'
  | 'family'
  | 'account'
  | 'more'
  | 'meals'
  | 'timetable'
  | 'plus'
  | 'check'
  | 'close'
  | 'chevron-down'
  | 'chevron-left'
  | 'chevron-right'
  | 'search'
  | 'drag'
  | 'edit'
  | 'trash'
  | 'sun'
  | 'moon'
  | 'system'
  | 'clock'
  | 'copy'
  | 'allowance'
  | 'budget'
  | 'contacts'
  | 'bell'
  | 'automation'
  | 'stats'

const pfade: Record<SymbolName, string> = {
  home: 'M3.5 10.5 L12 3.5 L20.5 10.5 V19 C20.5 20.1 19.6 21 18.5 21 H14.5 V14.5 C14.5 13.7 13.8 13 13 13 H11 C10.2 13 9.5 13.7 9.5 14.5 V21 H5.5 C4.4 21 3.5 20.1 3.5 19 Z',
  calendar:
    'M4 6.5 C4 5.1 5.1 4 6.5 4 H17.5 C18.9 4 20 5.1 20 6.5 V18.5 C20 19.9 18.9 21 17.5 21 H6.5 C5.1 21 4 19.9 4 18.5 Z M4 9.5 H20 M8 2.5 V5.5 M16 2.5 V5.5 M8.5 13.5 h0.01 M12 13.5 h0.01 M15.5 13.5 h0.01 M8.5 17 h0.01 M12 17 h0.01 M15.5 17 h0.01',
  tasks: 'M3.5 6.5 L6.5 9.5 L11 4.5 M14 7 H20.5 M3.5 15.5 L6.5 18.5 L11 13.5 M14 16 H20.5',
  shopping:
    'M3 3.5 H5.5 L7.8 15 C8 15.8 8.7 16.5 9.5 16.5 H18.5 C19.3 16.5 20 15.8 20.2 15 L21.5 7.5 H6.5 M9 20 h0.01 M17.5 20 h0.01',
  activity: 'M3 12 H6.5 L9 4.5 L14 19.5 L17.5 9.5 L19.5 12 H21',
  family:
    'M9 10 A 3.5 3.5 0 1 0 9 3 A 3.5 3.5 0 1 0 9 10 Z M17 11 A 2.5 2.5 0 1 0 17 6 A 2.5 2.5 0 1 0 17 11 Z M2.5 21 C2.5 16.5 5.5 13.5 9 13.5 C11.5 13.5 13.8 15 14.8 17.2 M14.5 21 C14.5 18 16 15.5 18.5 15.5 C20.5 15.5 22 17.5 22 21',
  account:
    'M12 11 A 4 4 0 1 0 12 3 A 4 4 0 1 0 12 11 Z M4.5 20.5 C4.5 16.5 8 14 12 14 C16 14 19.5 16.5 19.5 20.5',
  more: 'M5 12 h0.01 M12 12 h0.01 M19 12 h0.01',
  meals:
    'M5 3.5 V8.5 C5 9.8 6 10.8 7.2 10.8 H7.8 C9 10.8 10 9.8 10 8.5 V3.5 M7.5 3.5 V8.5 M7.5 10.8 V20.5 M16.5 3.5 C14.5 3.5 13.5 5.5 13.5 8.5 C13.5 11.5 14.5 13 16.5 13 C18.5 13 19.5 11.5 19.5 8.5 C19.5 5.5 18.5 3.5 16.5 3.5 Z M16.5 13 V20.5',
  timetable:
    'M4.5 4 C4.5 3.2 5.2 2.5 6 2.5 H18 C18.8 2.5 19.5 3.2 19.5 4 V20 C19.5 20.8 18.8 21.5 18 21.5 H6 C5.2 21.5 4.5 20.8 4.5 20 Z M4.5 8 H19.5 M10 8 V21.5 M10 14.5 H19.5',
  plus: 'M12 4.5 V19.5 M4.5 12 H19.5',
  check: 'M4.5 12.5 L9.5 17.5 L19.5 6.5',
  close: 'M6 6 L18 18 M18 6 L6 18',
  'chevron-down': 'M6.5 9 L12 14.5 L17.5 9',
  'chevron-left': 'M14.5 6.5 L9 12 L14.5 17.5',
  'chevron-right': 'M9.5 6.5 L15 12 L9.5 17.5',
  search: 'M10.5 17.5 A 7 7 0 1 0 10.5 3.5 A 7 7 0 1 0 10.5 17.5 Z M15.5 15.5 L20.5 20.5',
  drag: 'M8.5 6.5 h0.01 M15.5 6.5 h0.01 M8.5 12 h0.01 M15.5 12 h0.01 M8.5 17.5 h0.01 M15.5 17.5 h0.01',
  edit: 'M3.5 20.5 L7.5 19.5 L19 8 C19.8 7.2 19.8 6 19 5.2 L18.8 5 C18 4.2 16.8 4.2 16 5 L4.5 16.5 Z M14.5 6.5 L17.5 9.5',
  trash:
    'M4 6.5 H20 M9 6.5 V4 C9 3.5 9.5 3 10 3 H14 C14.5 3 15 3.5 15 4 V6.5 M5.5 6.5 L6.8 19.2 C6.9 20.2 7.8 21 8.8 21 H15.2 C16.2 21 17.1 20.2 17.2 19.2 L18.5 6.5 M10 10.5 V16.5 M14 10.5 V16.5',
  sun: 'M12 16.5 A 4.5 4.5 0 1 0 12 7.5 A 4.5 4.5 0 1 0 12 16.5 Z M12 2.5 V4.5 M12 19.5 V21.5 M2.5 12 H4.5 M19.5 12 H21.5 M5.3 5.3 L6.7 6.7 M17.3 17.3 L18.7 18.7 M5.3 18.7 L6.7 17.3 M17.3 6.7 L18.7 5.3',
  moon: 'M19.5 14.5 C18.8 14.8 18 15 17.2 15 C12.8 15 9.2 11.4 9.2 7 C9.2 5.5 9.6 4.1 10.3 2.9 C5.9 3.5 2.5 7.3 2.5 12 C2.5 17.2 6.8 21.5 12 21.5 C15.6 21.5 18.7 19.5 20.3 16.5 C20 16.5 19.7 16.5 19.5 16.5 Z',
  system: 'M3.5 5 C3.5 4.2 4.2 3.5 5 3.5 H19 C19.8 3.5 20.5 4.2 20.5 5 V15.5 C20.5 16.3 19.8 17 19 17 H5 C4.2 17 3.5 16.3 3.5 15.5 Z M12 17 V20.5 M7.5 20.5 H16.5',
  clock: 'M12 21 A 9 9 0 1 0 12 3 A 9 9 0 1 0 12 21 Z M12 7 V12 L15.5 14.5',
  copy: 'M8.5 8.5 H18.5 C19.3 8.5 20 9.2 20 10 V19.5 C20 20.3 19.3 21 18.5 21 H8.5 C7.7 21 7 20.3 7 19.5 V10 C7 9.2 7.7 8.5 8.5 8.5 Z M4 15.5 V4.5 C4 3.7 4.7 3 5.5 3 H14.5 C15.3 3 16 3.7 16 4.5 V6.5',
  allowance:
    'M12 21 A 9 9 0 1 0 12 3 A 9 9 0 1 0 12 21 Z M15.5 8.5 C14.5 7.5 13.2 7 11.8 7 C9.2 7 7.2 9.2 7.2 12 C7.2 14.8 9.2 17 11.8 17 C13.2 17 14.5 16.5 15.5 15.5 M6 10.5 H13 M6 13.5 H13',
  budget:
    'M3.5 6 C3.5 4.9 4.4 4 5.5 4 H18.5 C19.6 4 20.5 4.9 20.5 6 V18 C20.5 19.1 19.6 20 18.5 20 H5.5 C4.4 20 3.5 19.1 3.5 18 Z M3.5 10 H20.5 M7 15 H12 M16 13 V17',
  contacts:
    'M6.5 3.5 H18.5 C19.3 3.5 20 4.2 20 5 V19 C20 19.8 19.3 20.5 18.5 20.5 H6.5 C5.7 20.5 5 19.8 5 19 V5 C5 4.2 5.7 3.5 6.5 3.5 Z M3 7 H5 M3 12 H5 M3 17 H5 M12.5 10 A 2 2 0 1 0 12.5 9.99 M9.5 16.5 C9.5 14.5 11 13 12.5 13 C14 13 15.5 14.5 15.5 16.5',
  bell: 'M5.5 17 H18.5 L17.5 15.5 V10.5 C17.5 7.5 15 5 12 5 C9 5 6.5 7.5 6.5 10.5 V15.5 Z M12 2.5 V5 M9.5 17.5 C9.8 19 10.8 20 12 20 C13.2 20 14.2 19 14.5 17.5',
  automation: 'M13 2.5 L4.5 13.5 H12 L11 21.5 L19.5 10.5 H12 Z',
  stats: 'M3.5 20.5 H20.5 M6.5 20.5 V14.5 M12 20.5 V8.5 M17.5 20.5 V4.5',
}

/**
 * ⚠️ `width`/`height` stehen als ATTRIBUTE am SVG, nicht im Stylesheet.
 *
 * Ein SVG ohne Maß ist 100 % × 100 % seines Platzes: ein Zeichen, dessen
 * Verwendung keine Größe mitbringt, wuchs damit auf 200 px (im Bild eines
 * Aufklappers gesehen). Als Darstellungs-Attribut verliert das Grundmaß
 * gegen JEDE Regel im Stylesheet - die bestehenden Größen an Knopf, Pille
 * und Haupthandlung gelten unverändert weiter, und wer nichts angibt,
 * bekommt trotzdem ein vernünftiges Zeichen.
 */
export function Symbol({ name, ...props }: { name: SymbolName } & SVGProps<SVGSVGElement>) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d={pfade[name]} />
    </svg>
  )
}
